import { getCookie } from '~/lib/.client/cookie';
import { REFERRAL_ID_PARAM } from '~/lib/constants';

/**
 * So the current location URL is kind like an un-typed store that we use
 * all over the place.
 *
 * By moving some of that logic here, hopefully it's more discoverable and
 * easier to see if there could be potential collisions.
 */
export function getReferrerId(): string | undefined {
  try {
    const rid = new URLSearchParams(window.location.search).get(REFERRAL_ID_PARAM);

    if (rid) {
      return rid;
    }

    return getCookie(REFERRAL_ID_PARAM) ?? undefined;
  } catch {
    return undefined;
  }
}
